<div class="p-6 max-w-lg">
    <div class="flex items-start gap-3 mb-5">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">schedule_send</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'latePayment.dialogTitle' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ data.parkingSpace.name }}</p>
        </div>
    </div>

    <p class="text-sm text-slate-500 mb-5">{{ 'latePayment.dialogIntro' | translate }}</p>

    <!-- Enabled -->
    <div class="flex items-center justify-between py-3 border-t border-slate-100">
        <div class="pr-4">
            <div class="text-sm font-medium text-slate-900">{{ 'latePayment.enabled' | translate }}</div>
            <div class="text-xs text-slate-500 mt-0.5">{{ 'latePayment.enabledHint' | translate }}</div>
        </div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
            <input type="checkbox" class="sr-only peer" [checked]="enabled()"
                   (change)="enabled.set($any($event.target).checked)" />
            <div class="w-11 h-6 bg-slate-200 rounded-full transition-colors peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-100 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:border after:border-slate-300 after:transition-all peer-checked:after:translate-x-5 peer-checked:after:border-white"></div>
        </label>
    </div>

    @if (gatedWarning()) {
    <div class="flex gap-2 p-3 rounded-lg bg-amber-50 border border-amber-200 text-amber-900 text-xs mb-1">
        <mat-icon class="!w-4 !h-4 !text-[16px] leading-4 shrink-0 mt-0.5">warning</mat-icon>
        <span>{{ 'latePayment.gatedWarning' | translate }}</span>
    </div>
    }

    @if (enabled()) {
    <!-- Payment window -->
    <div class="py-3 border-t border-slate-100">
        <label class="text-sm font-medium text-slate-900" for="lp-window">
            {{ 'latePayment.windowHours' | translate }}
        </label>
        <div class="text-xs text-slate-500 mt-0.5 mb-2">{{ 'latePayment.windowHoursHint' | translate }}</div>
        <input id="lp-window" type="number" min="1" max="8760"
               class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
               [ngModel]="windowHours()" (ngModelChange)="windowHours.set($event)" />
        @if (windowHours() === null || (windowHours() ?? 0) < 1) {
        <div class="text-xs text-red-600 mt-1">{{ 'latePayment.windowHoursRequired' | translate }}</div>
        }
    </div>

    <!-- Ceiling -->
    <div class="py-3 border-t border-slate-100">
        <label class="text-sm font-medium text-slate-900" for="lp-max">
            {{ 'latePayment.maxAmount' | translate }}
        </label>
        <div class="text-xs text-slate-500 mt-0.5 mb-2">{{ 'latePayment.maxAmountHint' | translate }}</div>
        <input id="lp-max" type="number" min="0.01" step="0.01"
               class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
               [placeholder]="'latePayment.maxAmountUncapped' | translate"
               [ngModel]="maxAmount()" (ngModelChange)="maxAmount.set($event === '' ? null : $event)" />
    </div>

    <!-- Abandoned stay threshold -->
    <div class="py-3 border-t border-slate-100">
        <label class="text-sm font-medium text-slate-900" for="lp-abandoned">
            {{ 'latePayment.abandonedThreshold' | translate }}
        </label>
        <div class="text-xs text-slate-500 mt-0.5 mb-2">{{ 'latePayment.abandonedThresholdHint' | translate }}</div>
        <input id="lp-abandoned" type="number" min="1" max="8760"
               class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
               [placeholder]="'latePayment.abandonedThresholdNone' | translate"
               [ngModel]="abandonedStayThresholdHours()"
               (ngModelChange)="abandonedStayThresholdHours.set($event === '' ? null : $event)" />
    </div>
    }

    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ 'common.cancel' | translate }}</jjames-button>
        <jjames-button variant="primary" [disabled]="!canSave()" [loading]="isSaving()" (clicked)="onSave()">
            {{ 'common.save' | translate }}
        </jjames-button>
    </div>
</div>
